export default {
	setAnalyticsData (state, payload) {
		this._vm.$set(state, 'analytics', payload)
	},
	setTopCampaigns (state, payload) {
		this._vm.$set(state, 'topCampaigns', payload.slice(0, 5))
	},
	updateStats (state, payload) {
		this._vm.$set(state, 'dateRange', payload)
	},
	dismissWelcomeBack (state, dismissed = true) {
		this._vm.$set(state, 'dismissedWelcomeBack', Boolean(dismissed))
	},
}
